import { type Feature, type PlanTier, canAccessFeature } from "@reactive-resume/utils";
import { useCallback } from "react";

import { useUser } from "@/client/services/user";
import { useBillingStore } from "@/client/stores/billing";

export { canAccessFeature };
export type { Feature };

export function useFeatureGate() {
  const { user } = useUser();
  const planTier = (user?.planTier ?? null) as PlanTier;
  const openPaywall = useBillingStore((s) => s.openPaywall);

  const gate = useCallback(
    (feature: Feature): boolean => {
      if (canAccessFeature(planTier, feature)) return true;
      openPaywall(feature);
      return false;
    },
    [planTier, openPaywall],
  );

  const hasAccess = useCallback(
    (feature: Feature): boolean => canAccessFeature(planTier, feature),
    [planTier],
  );

  const requirePlan = useCallback(
    (message?: string): boolean => {
      if (planTier) return true;
      openPaywall(undefined, message);
      return false;
    },
    [planTier, openPaywall],
  );

  return { gate, hasAccess, requirePlan, planTier };
}
